module.exports = __webpack_public_path__ + "static/img/zongji4.042b358c.png";